import { ReactComponent as Icon } from "../images/error-icon.svg";

const ErrorIcon  = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};

export default ErrorIcon;
